  (function () {
    function initProductGallery() {
      var galleries = document.querySelectorAll('[data-product-gallery]');

      galleries.forEach(function (gallery) {
        var mainImage = gallery.querySelector('[data-gallery-main]');
        var thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');

        thumbnails.forEach(function (thumbnail) {
          thumbnail.addEventListener('click', function () {
            if (!mainImage) return;

            mainImage.classList.add('is-fading');

            setTimeout(function () {
              mainImage.src = thumbnail.dataset.fullSrc;
              mainImage.srcset = thumbnail.dataset.fullSrcset || '';
              mainImage.onload = function () {
                mainImage.classList.remove('is-fading');
                mainImage.onload = null;
              };
            }, 250);

            thumbnails.forEach(function (item) {
              item.classList.toggle('is-active', item === thumbnail);
            });
          });
        });
      });
    }

    function initQuantitySteppers() {
      var wrappers = document.querySelectorAll('[data-quantity-wrapper]');

      wrappers.forEach(function (wrapper) {
        var input = wrapper.querySelector('[data-quantity-input]');
        var decrease = wrapper.querySelector('[data-quantity-decrease]');
        var increase = wrapper.querySelector('[data-quantity-increase]');

        if (!input || !decrease || !increase) return;

        decrease.addEventListener('click', function () {
          var current = parseInt(input.value, 10);
          var value = Math.max(1, (isNaN(current) ? 1 : current) - 1);
          input.value = value;
        });

        increase.addEventListener('click', function () {
          var current = parseInt(input.value, 10);
          var value = (isNaN(current) ? 1 : current) + 1;
          input.value = value;
        });
      });
    }

    function initVariantPriceUpdates() {
      var galleries = document.querySelectorAll('[data-product-gallery]');

      galleries.forEach(function (gallery) {
        var select = gallery.querySelector('.product__variant-select');
        var price = gallery.querySelector('[data-product-price]');
        var buttonPrice = gallery.querySelector('[data-product-button-price]');

        if (!select || select.dataset.priceUpdateBound) return;

        select.dataset.priceUpdateBound = 'true';
        select.addEventListener('change', function () {
          var selectedOption = select.options[select.selectedIndex];
          if (!selectedOption || !selectedOption.dataset.price) return;
          if (price) price.textContent = selectedOption.dataset.price;
          if (buttonPrice) buttonPrice.textContent = selectedOption.dataset.price;
        });
      });
    }

    function initMobileStickyPurchaseControls() {
      var galleries = document.querySelectorAll('[data-product-gallery]');

      galleries.forEach(function (gallery) {
        var sentinel = gallery.querySelector('[data-sticky-controls-sentinel]');
        var controls = gallery.querySelector('.product__sticky-controls');
        var spacer = gallery.querySelector('.product__sticky-controls-spacer');

        if (!sentinel || !controls || !spacer || controls.dataset.mobileStickyBound) return;

        controls.dataset.mobileStickyBound = 'true';
        var frame = null;
        var mobileModeInitialized = false;
        var controlsInitiallyVisible = false;
        var hasScrolled = false;

        function update() {
          frame = null;
          var isMobile = window.matchMedia('(max-width: 750px)').matches;

          if (!isMobile) {
            controls.classList.remove('is-fixed');
            spacer.classList.remove('is-active');
            spacer.style.height = '';
            document.documentElement.style.removeProperty('--mobile-sticky-controls-footer-space');
            controls.style.transform = '';
            controls.style.transition = '';
            mobileModeInitialized = false;
            return;
          }

          var controlHeight = controls.getBoundingClientRect().height;
          var naturalBottom = sentinel.getBoundingClientRect().top + controlHeight;
          if (!mobileModeInitialized) {
            var initialRect = controls.getBoundingClientRect();
            controlsInitiallyVisible = initialRect.top >= 0 && initialRect.bottom <= window.innerHeight;
            mobileModeInitialized = true;
          }

          var shouldFix = window.scrollY > 0
            && naturalBottom <= window.innerHeight
            && (!controlsInitiallyVisible || hasScrolled);
          var wasFixed = controls.classList.contains('is-fixed');

          if (shouldFix !== wasFixed) {
            var previousTop = controls.getBoundingClientRect().top;

            controls.classList.toggle('is-fixed', shouldFix);
            spacer.classList.toggle('is-active', shouldFix);
            spacer.style.height = shouldFix ? `${controlHeight}px` : '';

            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              var newTop = controls.getBoundingClientRect().top;
              var topOffset = previousTop - newTop;

              if (Math.abs(topOffset) > 1) {
                controls.style.transition = 'none';
                controls.style.transform = `translateY(${topOffset}px)`;
                controls.offsetHeight;
                window.requestAnimationFrame(function () {
                  controls.style.transition = '';
                  controls.style.transform = '';
                });
              }
            }
          }

          if (shouldFix) {
            document.documentElement.style.setProperty('--mobile-sticky-controls-footer-space', `${controlHeight}px`);
          } else {
            document.documentElement.style.removeProperty('--mobile-sticky-controls-footer-space');
          }
        }

        function scheduleUpdate() {
          if (frame !== null) return;
          frame = window.requestAnimationFrame(update);
        }

        window.addEventListener('scroll', function () {
          hasScrolled = true;
          scheduleUpdate();
        }, { passive: true });
        window.addEventListener('resize', scheduleUpdate);
        scheduleUpdate();
      });
    }

    function init() {
      initProductGallery();
      initQuantitySteppers();
      initVariantPriceUpdates();
      initMobileStickyPurchaseControls();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('[data-product-gallery]')) {
        init();
      }
    });
  })();